import { erpAxios } from '..';

const insertAnalysis = async (data) => {
  const res = await erpAxios.post(`/analiza/add`, data);
  return res;
};

export default insertAnalysis;
